[
  {
    "dia": 15,
    "mupi": 3,
    "hora": "10h45min",
    "numero": 33,
    "titulo": "Ortopedia dentofacial no tratamento da Síndrome Obstrutiva da Apneia do Sono Pediátrica: state of art",
    "autor": "Óscar Gonçalves"
  },
  {
    "dia": 15,
    "mupi": 3,
    "hora": "10h52min",
    "numero": 34,
    "titulo": "ESTÉTICA DO SORRISO: REVISÃO NARRATIVA",
    "autor": "Bárbara Vieira"
  },
  {
    "dia": 15,
    "mupi": 3,
    "hora": "10h59min",
    "numero": 38,
    "titulo": "Extracellular Vesicles for Endodontic Applications: New Clinical and Research Approaches",
    "autor": "Teresa Santos"
  },
  {
    "dia": 15,
    "mupi": 3,
    "hora": "11h06min",
    "numero": 36,
    "titulo": "USO DE APÓSITOS INTRA-ALVEOLARES APÓS UMA EXTRAÇÃO DENTÁRIA: REVISÃO NARRATIVA",
    "autor": "Maria Dias"
  },
  {
    "dia": 15,
    "mupi": 3,
    "hora": "11h13min",
    "numero": 37,
    "titulo": "Impacto dos Inibidores Seletivos da Recaptação de Serotonina na Cirurgia Oral",
    "autor": "Sofia Correia"
  }
]